import React ,{useState,useEffect}from "react";
import Graph from "react-graph-vis";
import Service from "src/api/Service";
import customer from '../assets/images/nextIcons/Customer.png';
import customerA from 'src/assets/images/nextIcons/CustomerA.png';
import factory from 'src/assets/images/nextIcons/factory.png';
import factoryA from 'src/assets/images/nextIcons/factoryA.png';
import warehouse from 'src/assets/images/nextIcons/warehouse.png';
import warehouseA from 'src/assets/images/nextIcons/warehouseA.png';
import depot from 'src/assets/images/nextIcons/Depot.png';
import depotA from 'src/assets/images/nextIcons/DepotA.png';
import retailer from 'src/assets/images/nextIcons/retailer.png';
import retailerA from 'src/assets/images/nextIcons/retailerA.png';
import { Modal, Button } from 'react-bootstrap';
import AlertComponent from './AlertComponent';


const NewNetworkDiagram = () => {
    const [isLoading, setisLoading] = useState(true);
  const [topology, setTopology] = useState({});
  const [visible, setVisible] = useState(false);
  const [Alert, setAlert] = useState([]);
    const graph = topology;
    
      const options = {
        // layout: {
        //   hierarchical: {
        //     direction: "LR",
        //   },
        // },

        physics: {
            enabled: false,
          },
        edges: {
          color: "#000000",
          shadow: true,
          arrows: {
            to: {
              scaleFactor: 5
            }
          }
        },
        nodes: {
            borderWidth: 2,
            size: 130,
            shadow: true,
            font: {
                size: 102,
                color: "#AA00C5",
            },
          },
        height: "500px"
      };

      console.log(topology);
      const fetchData = async () => {
        let temp = {};
        temp.nodes = [];
        temp.edges = [];

        await Service.get("config/tabNetworkConfigurator",(status,data)=>{
            if(status==200){
                data['data'].map((ele=>{
                    var  Icon= ele['alertflag']=='A'? ele['icontype']+'A':ele['icontype'];           
                    var  color= ele['alertflag']=='A'? 'black' :'black';  
                   
                  
                        if(Icon=="customer")
                            temp.nodes.push({ id: parseInt(ele['id']),label: ele['name'],  x:500, y: 10, image:customer, shape: "image"});  
              
                        else if(Icon=="customer")
                            temp.nodes.push({ id: parseInt(ele['id']),label: ele['name'],   x:parseInt( ele['x']), y: parseInt(ele['y']), image:customerA, shape: "image"});  
              
                        else if(Icon=="customer")
                            temp.nodes.push({ id: parseInt(ele['id']),label: ele['name'],  x:parseInt( ele['x']), y: parseInt(ele['y']), image:factory, shape: "image"});  
              
                        else if(Icon=="factoryA")
                            temp.nodes.push({ id: parseInt(ele['id']),label: ele['name'],  x:parseInt( ele['x']), y: parseInt(ele['y']), image:factoryA, shape: "image"});  

                        else if(Icon=="factory")
                            temp.nodes.push({ id: parseInt(ele['id']),label: ele['name'],  x:parseInt( ele['x']), y: parseInt(ele['y']), image:factory, shape: "image"});

                        else if(Icon=="warehouse")
                            temp.nodes.push({ id: parseInt(ele['id']),label: ele['name'],  x:parseInt( ele['x']), y: parseInt(ele['y']), image:warehouse, shape: "image"});  
              
                        else if(Icon=="warehouseA")
                            temp.nodes.push({ id: parseInt(ele['id']),label: ele['name'],  x:parseInt( ele['x']), y: parseInt(ele['y']), image:warehouseA, shape: "image"});  
              
                        else if(Icon=="depot")
                            temp.nodes.push({ id: parseInt(ele['id']),label: ele['name'],  x:parseInt( ele['x']), y: parseInt(ele['y']), image:depot, shape: "image"});  
             
                        else if(Icon=="depotA")
                            temp.nodes.push({ id: parseInt(ele['id']),label: ele['name'],  x:parseInt( ele['x']), y: parseInt(ele['y']), image:depotA, shape: "image"});  
             
                        else if(Icon=="retailer")
                            temp.nodes.push({ id: parseInt(ele['id']),label: ele['name'],  x:parseInt( ele['x']), y: parseInt(ele['y']), image:retailer, shape: "image"});  
             
                        else if(Icon=="retailerA")
                            temp.nodes.push({ id: parseInt(ele['id']),label: ele['name'],  x:parseInt( ele['x']), y: parseInt(ele['y']), image:retailerA, shape: "image"});  
             

                       

                       if(ele['target_id'] != null){
                        JSON.parse(ele['target_id']).forEach(function (item, index) {
                          var tid=  JSON.parse(ele['target_id']);
                          var color= ele['linkcolor']==null? 'black' :ele['linkcolor']; 
                          temp.edges.push({ from: parseInt(ele['id']), to: parseInt( tid[index])});
                        });
                      }
                }));
                setTopology(temp);
                setisLoading(false);
            }
        })
      }
      useEffect(()=>{
        fetchData();    
     
     },[]);

      const events = {
        select: function(event) {
          var { nodes, edges } = event;
          console.log(nodes);

          var nodeName= "";
          console.log(event);
          for (var i = 0; i < topology['nodes'].length; i++) {       
             if(topology['nodes'][i]['id']==nodes){
              nodeName=topology['nodes'][i]['label'];
              break;
             }
          }
          var data={
            id:nodes[0],
            name: nodeName
          }

          setAlert(data);
          setVisible(!visible);
        },
        // dragEnd:function(event){
        //     setisLoading(true);
        //     var { nodes, edges,x,y ,pointer} = event;
        //     console.log(nodes);
        //     console.log(nodes[0]);
           
        // var obj = {};
        // obj['x']= pointer['DOM']['x'];
        // obj['y']= pointer['DOM']['y'];
        // console.log(obj);
        // // Service.put("config/tabNetworkConfigurator/"+nodes[0],obj,(status,data)=>{
        // // if(status==201){           
        // //   fetchData();
        // //  }else if(status==400){          
        // //     }
        // //  });
        // }
      };

      if(isLoading){
        return (<>...</>);
      }
      return (
        <>
          <Graph
          graph={graph}
          options={options}
          events={events}
          getNetwork={network => {
            //  if you want access to vis.js network api you can set the state in a parent component using this property
          }}
        />
      <Modal show={visible}  size="lg" >
                <Modal.Header closeButton onClick={() => setVisible(!visible)} >
                  <Modal.Title>{Alert['name']}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <AlertComponent id={Alert['id']}/>

                </Modal.Body>

              </Modal>
        </>
      );
    }
    
export default NewNetworkDiagram;